<template>
<div v-can="'Read_Formula'">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h1 class="text-left">{{$tc('general.formulation', 2)}}</h1>
        <MainGrid gridTitle="Formulations" objectNodeName="entityModels" endpoint="formula" :gridColumns="columns" :filter="filter" formUrl="/formulation" :queryByFilter="true" :customOrderBy="true" deletedataToDisplay="name" :deleteAssociatedData="$store.state.formulation.associatedData" :deleteEndpointToDelete="$store.state.formulation.endpointToDelete"></MainGrid>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MainGrid from '../components/MainGrid'

export default {
  name: 'Formulations',
  components: {
    MainGrid
  },
  data() {
    return {
      title: 'Formulations',
      columns: [
        {
          label: this.$t('formulation.id'),
          key: "prefixId",
          sortable: true
        },
        {
          label: this.$t('formulation.formulationName'),
          key: "name",
          sortable: true,
          initial_sort: true
        },
        {
          label: this.$t('formulation.version'),
          key: "version",
          sortable: true
        },
        {
          label: this.$t('general.status'),
          key: "statusName",
          sortable: true,
        },
        {
          label: this.$t('general.clientName'),
          key: "companyName",
          sortable: true
        },
        {
          label: this.$t('project.projectName'),
          key: "projectName",
          sortable: true
        },
        {
          label: this.$t('product.productName'),
          key: "productName",
          sortable: true
        },
        {
          key: "actionButtons",
          label: "",
        }
      ],
      filter: [{
        method: "findByClientProjectProduct",
        params: ["searchValue"]
      }]
    }
  }
}
</script>

<style>
.btn-icon{
  cursor: pointer;
  margin: 0px 5px;
}

</style>
